import { render, staticRenderFns } from "./pageTest.vue?vue&type=template&id=7ecbbdd2&scoped=true"
import script from "./pageTest.vue?vue&type=script&lang=js"
export * from "./pageTest.vue?vue&type=script&lang=js"
import style0 from "./pageTest.vue?vue&type=style&index=0&id=7ecbbdd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecbbdd2",
  null
  
)

export default component.exports